
<div class="row">

    <div class="col-8">
        <!-- Current coordinate system -->
        <span *ngIf="dataset && dataset?.crs?.name && !loading">{{ 'FILE_LIST.TILING_WIZARD.COORDINATE_CURRENT' | translate: dataset }}</span>
        
        <!-- Select coordinate system -->
        <span *ngIf="!dataset?.crs?.name">{{ 'FILE_LIST.TILING_WIZARD.COORDINATE_CURRENT_NONE' | translate }}</span>
        <div style="max-height:640px !important">
            <map-viewer name="align"></map-viewer>
        </div>
    </div>

    <!-- Selected EPSG code -->
    <div class="col-4" *ngIf="dataset && dataset?.initParams">
        <span style="font-weight: bold">{{'MAP.PHOTOGRAM.SELECTED_EPSG_CODE' | translate }} </span>

        <div qmap-question [model]="dataset" [qMap]="{
            id:'crs',
            style:'combo',
            type:'object',
            obj_type:'EPSGCodes'
        }" (qmap-change)="changed()"></div>

        <!-- Coordinate shift -->
        <span style="font-weight: bold">{{'FILE_LIST.TILING_WIZARD.COORDINATE_SHIFT' | translate }} : </span>
        <div  qmap-question [model]="dataset.initParams" (qmap-change)="changed()" [qMap]="{id:'easting',title:'FILE_LIST.TILING_WIZARD.EASTING' | translate,type:'number'}"></div>
        <div  qmap-question [model]="dataset.initParams" (qmap-change)="changed()" [qMap]="{id:'northing',title:'FILE_LIST.TILING_WIZARD.NORTHING' | translate,type:'number'}"></div>
        <div  qmap-question [model]="dataset.initParams" (qmap-change)="changed()" [qMap]="{id:'height',title:'GENERIC.HEIGHT' | translate,type:'number'}"></div>
    </div>

</div>